import { useEffect, useState } from 'react';
import { SxProps, Box, Typography } from '@mui/material';
import BoxPlot, { Group } from '../../ui/BoxPlot';
import PercentileColorKey from '../../features/PercentileColorKey';
import { Measure, PopulationAndType } from '../../utils/dataTypes';
import { getColorGradient } from '../../utils/helpers';

type MeasureGroups = {
  measureName: string;
  groups: Group[];
}

/**
 * JSX Component containing measure score graphs
 * 
 * @param measures: Measure[] - measures selected for score graph viewing
 * 
 * @returns MeasureGraphs element
 */
export const MeasureGraphs = ({ measures, populationData }: { measures: Measure[], populationData: PopulationAndType }): JSX.Element => {
  const [allBoxGroups, setAllBoxGroups] = useState<MeasureGroups[]>([]);

  useEffect(() => {
    const getBoxGroups = async () => {
      const measureGroups = measures.map((measure) => {
      	let clientGroup = null;
      	if (measure.actualScore && measure.percentile) {
      		clientGroup = {
            title: 'Client Score',
            value: measure.actualScore,
            percentile: measure.percentile,
            color: getColorGradient((measure.percentile)).backgroundColor,
          };
      	}
        const populationName = populationData.population ? `${populationData.population.split("(")[1].split(")")[0]}`: 'General Population';
        // Always include the population group; BoxPlot shows a note when its box is null
        const populationGroup: Group = { title: populationName, box: measure.quantiles ?? null };
      	const groups = clientGroup ? [clientGroup, populationGroup] : [populationGroup];
      	return { measureName: measure.measureName, groups: groups };
    	});
    	setAllBoxGroups(measureGroups);
    };
    getBoxGroups();
  }, [measures, populationData]);

  const containerStyle: SxProps = {
    padding: '10px 5% 50px 5%',
    border: 'solid 2px #2b2b2b',
    borderRadius: '5px',
    margin: '10px auto 40px auto',
    backgroundColor: '#2b2b2b',
    width: '50%',
  };

  const textStyle: SxProps = {
    color: '#eef2f8',
    fontWeight: 'bold',
  };

  return (
    <Box>
      {
        measures &&
        measures.map((measure) => {
        	return (
	        	<Box sx={containerStyle}>
              <Typography sx={textStyle} key={measure.measureName}>
                {measure.measureName}
              </Typography>
	        	  <BoxPlot groups={allBoxGroups.find(({ measureName }) => measure.measureName === measureName)?.groups || []} />
              <PercentileColorKey />
	        	</Box>
	        );
        })
      }
    </Box>
  );
};

export const BoxAndWhiskerGraph = (
	{ boxAndWhiskerWidget, population }: { boxAndWhiskerWidget: string, population: string }
): JSX.Element => {
	return (
		<div></div>
	);
}

export default BoxAndWhiskerGraph;
